import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';

/** Chip for a namespace role. System roles get tier colors; custom roles are neutral. */
@Component({
    selector: 'app-role-badge',
    standalone: true,
    imports: [CommonModule, TagModule, TooltipModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `<p-tag [value]="label()" [severity]="severity()" [rounded]="true" [pTooltip]="tooltip()"></p-tag>`
})
export class RoleBadgeComponent {
    roleId = input<string>('');
    roleName = input<string>('');
    /** Optional extra context (e.g. namespace name) rendered before the role. */
    prefix = input<string>('');

    label = computed(() => {
        const name = this.roleName() || this.roleId();
        return this.prefix() ? `${this.prefix()} · ${name}` : name;
    });

    severity = computed<'success' | 'info' | 'warn' | 'secondary'>(() => {
        switch ((this.roleId() || '').toLowerCase()) {
            case 'admin':
                return 'warn';
            case 'writer':
                return 'info';
            case 'reader':
                return 'success';
            default:
                return 'secondary';
        }
    });

    tooltip = computed(() => {
        const id = (this.roleId() || '').toLowerCase();
        return ['admin', 'writer', 'reader'].includes(id) ? '' : 'Custom role';
    });
}
